import api from "./api";

/**
 * Loads AccountPerson.SecretTwoAuth for Google Authenticator pairing.
 * GET /v1/ib/accounts/me/authenticator
 */
export async function fetchAuthenticatorSecret() {
  const { data } = await api.get("/v1/ib/accounts/me/authenticator");
  const secret =
    String(
      data?.secret_two_auth ??
        data?.secretTwoAuth ??
        data?.secret_ach_two_auth ??
        data?.secretAchTwoAuth ??
        ""
    ).trim() || "";

  return {
    secret,
    otpauthUrl: String(data?.otpauth_url ?? data?.otpauthUrl ?? "").trim(),
    issuer: String(data?.issuer ?? "VALUT").trim() || "VALUT",
    account: String(data?.account ?? "").trim(),
  };
}
